import { Language } from 'ha/i18n';

import { ContentfulSupportedLangs } from '../constants';

export default (lang: Language) => ContentfulSupportedLangs.includes(lang);
